// One setting decides which n8n server the front end calls: VITE_N8N_BASE_URL.
// Unset or blank falls back to the self-hosted server. Paths are unchanged
// from the n8n Cloud days; only the host moves.

export const DEFAULT_N8N_BASE_URL = "https://n8n.seqformwork.com.au";

// Joins a base URL and a webhook path. A blank base uses the default.
export function buildN8nWebhookUrl(
  base: string | null | undefined,
  path: string,
): string {
  const trimmed = (base ?? "").trim().replace(/\/+$/, "");
  const host = trimmed === "" ? DEFAULT_N8N_BASE_URL : trimmed;
  return `${host}/webhook/${path.replace(/^\/+/, "")}`;
}
